// extracted by mini-css-extract-plugin
module.exports = {"each_section":"storesLocation_each_section__1vpcX"};